import { setProp } from '@/store/helper';
import * as types from '@/store/mutation-types';

export default {
  [types.SET_AUTH_USER]: setProp('user'),
  [types.SET_AUTH_EXPIRES_AT]: setProp('expiresAt'),
  [types.SET_AUTH_ACCESS_TOKEN]: setProp('accessToken'),
  [types.SET_STATUS_PENDING]: setProp('status.pending'),
};
